import Container from "components/atoms/layout/Container/Container";
import { AccountSettings } from "components/molecules/AccountSettings/AccountSettings";
import { PasswordChange } from "components/molecules/AccountSettings/PasswordChange";

export const AccountModule = () => {
  return (
    <Container className="p-10 flex flex-col gap-4">
      <AccountSettings />
      <PasswordChange />
    </Container>
  );
};
